import { Box } from "@mui/material";

const ZodiacSignQuiz = () => {
  return <Box>ZodiacSignQuiz</Box>;
};
export default ZodiacSignQuiz;
